module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.user.scope) ? _c('div', {
    staticClass: "content",
    class: {
      fullHeight: _vm.isSaving
    }
  }, [(!_vm.isSaving) ? _c('mu-card', {
    staticClass: "bottom"
  }, [_c('mu-card-header', {
    staticClass: "greyed aio-input-header",
    attrs: {
      "title": _vm.$t('message.labelTime'),
      "titleClass": "alignMiddle lightTitle"
    }
  }, [_c('mu-icon', {
    staticClass: "alignMiddle dateIcon",
    attrs: {
      "slot": "avatar",
      "value": "access_time"
    },
    slot: "avatar"
  })], 1), _vm._v(" "), _c('mu-card-text', [_c('p', [_vm._v(_vm._s(_vm.$t('message.labelProgressDatePickerExplain')))])]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "mobile",
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('date-picker', {
    attrs: {
      "iconMode": "",
      "type": "datetime"
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "50",
      "tablet": "50"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('aio-pictures', {
    staticClass: "bottom"
  }), _vm._v(" "), _c('aio-weight', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onWeightValid
    }
  }), _vm._v(" "), _c('aio-blood-glucose', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onBloodGlucoseValid
    }
  }), _vm._v(" "), _c('aio-hba1c', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onHba1cValid
    }
  }), _vm._v(" "), _c('aio-insulin', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onInsulinValid
    }
  }), _vm._v(" "), _c('aio-sleep', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onSleepValid
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('aio-ketones', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onKetonesValid
    }
  }), _vm._v(" "), _c('aio-blood-pressure', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onBloodPressureValid
    }
  }), _vm._v(" "), _c('aio-mood', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onMoodValid
    }
  }), _vm._v(" "), _c('aio-medication', {
    staticClass: "bottom",
    on: {
      "onValid": _vm.onMedicationValid
    }
  }), _vm._v(" "), _c('aio-cholesterol', {
    on: {
      "onValid": _vm.onCholesterolValid
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 48,
      "mode": "indeterminate",
      "color": "#0179d5 !important"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('message.savingText')) + "\n    ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.objectsHydrated > 0 && !_vm.isSaving && _vm.isFabShown === true) ? _c('mu-float-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.left",
      value: ('Save all'),
      expression: "'Save all'",
      modifiers: {
        "left": true
      }
    }],
    staticClass: "confirmFloat animated fadeIn",
    style: ({
      'right': _vm.getScrollbarWidth() + 24 + 'px'
    }),
    attrs: {
      "icon": "check",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.processQueue()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "scrollDetector"
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-327de616","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AddProgress/AddProgress.vue
// module id = 3114
// module chunks = 1